import { config } from '../appConfig'
import { ETH_CHAIN_ID } from '../constants/business'
import { Chain } from '../interfaces/common'
import {
  validateAccountId,
  validateBtcAddress,
  validateDogeAddress,
  validateEthAddress,
  validateLtcAddress,
  validatePrincipal,
  validateSolAddress,
} from '../utils/validationHelper'

export enum AddressType {
  AccountId,
  PrincipalId,
  Invalid,
  Eth,
  Sol,
  Btc,
  Doge,
  Ltc,
}

const addressMatcher = (address: string) => {
  if (!address) return AddressType.Invalid

  if (validateAccountId(address)) return AddressType.AccountId
  if (validatePrincipal(address)) return AddressType.PrincipalId
  if (validateEthAddress(address)) return AddressType.Eth
  if (validateSolAddress(address)) return AddressType.Sol
  if (validateBtcAddress(address)) return AddressType.Btc
  if (validateDogeAddress(address)) return AddressType.Doge
  if (validateLtcAddress(address)) return AddressType.Ltc

  if (config.fetchEnv('VITE_BITCOIN_CHAIN') === 'testnet' && address.startsWith('tb1'))
    return AddressType.Btc

  return AddressType.Invalid
}

export const addressToChain = (address: string) => {
  if (!address) return

  if (validateAccountId(address)) return Chain.ICP
  if (validatePrincipal(address)) return Chain.ICP
  if (validateSolAddress(address)) return Chain.SOL
  if (validateBtcAddress(address)) return Chain.BTC
  if (validateDogeAddress(address)) return Chain.DOGE
  if (validateLtcAddress(address)) return Chain.LTC
  if (validateEthAddress(address)) return ETH_CHAIN_ID.toString()
}

export default addressMatcher
